(function () {
  const initExpertSwipers = () => {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.js-product-expert-swiper').forEach((el) => {
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      const wrap = el.closest('.product__expert-carousel');
      const prev = el.querySelector('.pe__prev-button');
      const next = wrap ? wrap.querySelector('.pe__next-button') : el.querySelector('.pe__next-button');
      if (!prev || !next) return;

      new Swiper(el, {
        speed: 600,
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
    });
  };

  const run = () => {
    initExpertSwipers();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
